import { type VirtualBackgroundFilter } from '@doxyme/types';
import { type VirtualBackground, backgrounds } from './constants';
import { storage } from '@doxyme/ui/utils';
import { StorageKeys } from '../../../shared/constants';

const getVirtualBackgroundIndexFromLocalStorage = (userId?: string): number => {
  if (!Boolean(userId)) {
    return 0;
  }

  const storedIndex = storage.getItem(
    `${StorageKeys.VirtualBackgroundEffect}:${userId}`,
    true,
  );

  if (Boolean(storedIndex)) {
    return Number(storedIndex);
  }

  // 0 - default index without any background
  return 0;
};

export const getVirtualBackgroundFromLocalStorage = (
  userId?: string,
): VirtualBackground | undefined => {
  return backgrounds.find(
    (background) =>
      background.index === getVirtualBackgroundIndexFromLocalStorage(userId),
  );
};

export const getVirtualBackgroundFilterFromLocalStorage = (
  userId?: string,
): VirtualBackgroundFilter | undefined => {
  const bg = backgrounds.find(
    (background) =>
      background.index === getVirtualBackgroundIndexFromLocalStorage(userId),
  );

  return bg !== null && bg !== undefined && bg.index > 0 && bg.filter !== null
    ? bg.filter
    : undefined;
};

export const setVirtualBackgroundToLocalStorage = (
  background: VirtualBackground,
  userId: string,
): void => {
  storage.setItem(
    `${StorageKeys.VirtualBackgroundEffect}:${userId}`,
    background.index.toString(),
    true,
  );
};
